export default __webpack_public_path__ + "images/6cd054fd10a941d29b2f92f698919ead.png";